import coctail1Src from "../../images/coctail-01.png";
import coctail2Src from "../../images/coctail-02.png";
import coctail3Src from "../../images/coctail-03.png";
import coctail4Src from "../../images/coctail-04.png";
import coctail5Src from "../../images/coctail-05.png";

import slideBgSrc from "../../images/recipes-modal-bg.jpg";
import contentBgSrc from "../../images/not-available-jar.svg";

export const slides = [
  {
    id: 1,
    name: "Apple Pie Ginger",
    label: "Apple Pie Ginger",
    imageSrc: coctail1Src,
    imageBgSrc: slideBgSrc,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz Ole Smoky® Apple Pie Moonshine",
      },
      {
        id: 2,
        text: "3 oz Ginger Ale",
      },
    ],
    garnish: [],
    directions: [
      {
        id: 1,
        text: "Add ingredients over ice",
      },
      {
        id: 2,
        text: "Mix well",
      },
      {
        id: 3,
        text: "Shine Responsibly",
      },
    ],
  },
  {
    id: 2,
    name: "Blackberry Lemonade",
    label: "Blackberry Lemonade",
    imageSrc: coctail2Src,
    imageBgSrc: slideBgSrc,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz. Ole Smoky® Blackberry Moonshine",
      },
      {
        id: 2,
        text: "3 oz. Lemonade",
      },
    ],
    garnish: [],
    directions: [
      {
        id: 1,
        text: "Muddle the mint in the bottom of the glass",
      },
      {
        id: 2,
        text: "Add ingredients over ice and mix well",
      },
      {
        id: 3,
        text: "Shine Responsibly",
      },
    ],
  },
  {
    id: 3,
    name: "Hunch Punch Cooler",
    label: "Hunch Punch Cooler",
    imageSrc: coctail3Src,
    imageBgSrc: slideBgSrc,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "1.5 oz Hunch Punch Lightnin' Moonshine",
      },
      {
        id: 2,
        text: "3 oz. Lemonade",
      },
      {
        id: 3,
        text: ".25 oz Lemon Lime Soda",
      },
      {
        id: 4,
        text: ".25 oz Cranberry Juice",
      },
    ],
    garnish: [],
    directions: [
      {
        id: 1,
        text: "Add ingredients over ice",
      },
      {
        id: 2,
        text: "Mix well",
      },
      {
        id: 3,
        text: "Shine Responsibly",
      },
    ],
  },
  {
    id: 4,
    name: "Backyard Tea",
    label: "Backyard Tea",
    imageSrc: coctail4Src,
    imageBgSrc: slideBgSrc,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz. Ole Smoky Peach Whiskey",
      },
      {
        id: 2,
        text: "3 oz. Sweet or Unsweetened Iced Tea",
      },
    ],
    garnish: [],
    directions: [
      {
        id: 1,
        text: "Add ingredients over ice",
      },
      {
        id: 2,
        text: "Mix well",
      },
      {
        id: 3,
        text: "Drink Responsibly",
      },
    ],
  },
  {
    id: 5,
    name: "Watermelon Cooler",
    label: "Watermelon Cooler",
    imageSrc: coctail5Src,
    imageBgSrc: slideBgSrc,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "2 oz. Ole Smoky Salty Watermelon Whiskey",
      },
      {
        id: 2,
        text: "1.5 oz. Sour Mix",
      },
      {
        id: 3,
        text: "1 oz. Cranberry Juice",
      },
      {
        id: 4,
        text: ".25 oz Lemon-Lime Soda",
      },
    ],
    garnish: [],
    directions: [
      {
        id: 1,
        text: "Add ingredients over ice",
      },
      {
        id: 2,
        text: "Mix well",
      },
      {
        id: 3,
        text: "Drink Responsibly",
      },
    ],
  },
];

export const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
